const formatTime = (post) => {
  if(post.event_time){
    return `<time class="n__calendar__card__date">${post.event_time}</time>`;
  }
  return '';
}
const card = post => {
  return `
  <div class="col-xs-12 col-md-6 col-3 n__calendar__item__col">
  <article class="n__calendar__card">
    <div class="n__calendar__card__top">
      <a class="n__calendar__card__thumb" style="background-image: url(${post.img});" href="${post.url}"></a>
      <div class="n__calendar__card__tags">
        ${post.terms.length && post.show_btn ? '<div class="n__calendar__card__tag">'+post.terms[0].name+'</div>' : ''}
        ${post.tagas && post.show_btn ? '<div class="n__calendar__card__tag n__calendar__card__tag--red">'+post.tagas+'</div>' : ''}
      </div>
    </div>
    <h3 class="n__calendar__card__heading"><a href="${post.url}">${post.post_title}<a/></h3>
    <time class="n__calendar__card__date ${post.event_time ? 'n__calendar__card__date--no-margin' : ''}">${post.event_date}</time>
    ${formatTime(post)}
    <div class="n__calendar__card__buttons">
      <a href="${post.url}">${post.more_text}</a>
      ${post.button_text && post.button_url && post.show_btn ? '<a href="'+post.button_url+'">'+post.button_text+'</a>' : ''}
    </div>
  </article>
  </div>
  `;
};

export const formatHTML = posts => {
  let html = '';
  posts.forEach(post => {
    html += card(post);
  });
  return html; 
};